import React, { Component } from 'react';
import { BaseTextBox } from '../controls/BaseTextBox';
import { FormattedMessage } from 'react-intl';
import { SalesCodeComboBox } from './CustomerMade/SalesCodeComboBox';
//import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import authService from '../api-authorization/AuthorizeService';
import { BaseTextArea } from '../controls/BaseTextArea';
import Select from 'react-select';
import orderService from './OrderService';
import { BaseCheckBox } from '../controls/BaseCheckBox';

export class DealerView extends Component {

    constructor(props) {
        super(props);
        const { id, dealerName } = props.model;
        this.state = {
            dealerId: id, dealerName: dealerName, deliverCodes: [], deliverAccountCode: [], salesCodes: [], uploading: false, propertyChanged: false, otherPlatformSalesCode: [], defaultSalesCodes: [], showTooltip: false
        };
        // this.handleOnSearch = this.handleOnSearch.bind(this);
        // this.handleOnHover = this.handleOnHover.bind(this);
        //  this.handleOnSelect = this.handleOnSelect.bind(this);
        //  this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleSelectChanged = this.handleSelectChanged.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSalesCodeChanged = this.handleSalesCodeChanged.bind(this);
        this.changeSalesCodeSelect = this.changeSalesCodeSelect.bind(this);
        this.handleIsOtherPlatformChange = this.handleIsOtherPlatformChange.bind(this);
    }

    handleIsOtherPlatformChange(event) {
        const target = event.target;
        const value = target.value;
        const boolValue = this.stringToBool(value);

        var model = this.props.model;
        model.isOtherPlatform = !boolValue;
        let dealerName = this.state.dealerName;
        if (model.isOtherPlatform) {
            this.setState({ salesCodes: this.state.otherPlatformSalesCode.map(x => x.code) });
            if (this.state.otherPlatformSalesCode.length > 0) {
                dealerName = this.state.dealerName + "/" + this.state.otherPlatformSalesCode[0].dealerName;
                model.saleAccountCode = this.state.otherPlatformSalesCode[0].code;
            }
        } else {
            console.log(this.state.defaultSalesCodes);
            this.setState({ salesCodes: this.state.defaultSalesCodes });
            // console.log(this.state.defaultSalesCodes);
            if (this.state.defaultSalesCodes.length > 0) {
                model.saleAccountCode = this.state.defaultSalesCodes[0];
            }
            dealerName = this.state.dealerName.split('/')[0];
        }
        model.dealerName = dealerName;
       // console.log(model);
        this.setState({ dealerName: dealerName });
        this.notifyPropertyChanged();
    }

    stringToBool(str) {
        return str.toLowerCase() === 'true';
    }

    handleSalesCodeChanged(selectedValue) {
        var model = this.props.model;
        model.saleAccountCode = selectedValue;
        // console.log(selectedValue);
    }


    notifyPropertyChanged() {
        let propertyChanged = !this.state.propertyChanged;
        this.setState({ propertyChanged: propertyChanged });
    }
    handleTooltipClick = (e) => {
        e.preventDefault();
        this.setState(prevState => ({
            showTooltip: !prevState.showTooltip
        }));
    };
    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        var model = this.props.model;
        if (model) {
            switch (name) {
                case "addressee":
                    model.addressee = value;
                    break;
                case "zipcode":
                    model.zipcode = value;
                    break;
                case "phone":
                    model.phone = value;
                    break;
                case "address":
                    model.address = value;
                    break;
                case "lastEardrumNumber":
                    model.lastEardrumNumber = value;
                    break;
            }

            this.notifyPropertyChanged();
        }
    }
    handleSelectChanged(e) {
        var handler = this.onSelectChanged;
        if (handler) {
            handler(e);
        }
    }

    componentDidMount() {
        this.populateDeliverCodeData();
    }

    componentWillUnmount() {

    }

    //handleOnSearch(string, results) {
    //    // onSearch will have as the first callback parameter
    //    // the string searched and for the second the results.
    //    console.log(string, results)
    //}

    //handleOnHover(result) {
    //    // the item hovered
    //    console.log(result)
    //}

    //handleOnSelect(item) {
    //    // the item selected
    //    var deliverCodes = this.state.deliverCodes;

    //    deliverCodes.forEach((deliverCode) => {
    //        if (deliverCode.code === item.code) {
    //            var selSalesCode = '';
    //            var salesCodes = deliverCode.salesAccountCodes;
    //            if (salesCodes.length > 0) {
    //                selSalesCode = salesCodes[0]
    //            }
    //            let model = this.props.model;
    //            model.deliverAccountCode = deliverCode.code;
    //            model.saleAccountCode = selSalesCode;
    //            model.addressee = deliverCode.addressee;
    //            model.zipcode = deliverCode.zipcode;
    //            model.phone = deliverCode.phone;
    //            model.address = deliverCode.address;

    //            this.setState({ salesCodes: salesCodes });
    //        }
    //    });
    //}

    //handleOnFocus() {
    //    console.log('Focused')
    //}
    onSelectChange = selectedOption => {
        this.setState({
            deliverAccountCode: selectedOption
        })
        this.changeSalesCodeSelect(selectedOption);
        //var deliverCodes = this.state.deliverCodes;
        //deliverCodes.forEach((deliverCode) => {

        //    if (selectedOption!=null && deliverCode.code === selectedOption.value) {
        //        //console.log(deliverCode);
        //        var selSalesCode = '';
        //        var salesCodes = deliverCode.salesAccountCodes;
        //        if (salesCodes.length > 0) {
        //            selSalesCode = salesCodes[0]
        //        }
        //        let model = this.props.model;
        //        model.deliverAccountCode = deliverCode.code;
        //        model.saleAccountCode = selSalesCode;
        //        model.addressee = deliverCode.addressee;
        //        model.zipcode = deliverCode.zipcode;
        //        model.phone = deliverCode.phone;
        //        model.address = deliverCode.address;
        //        if (deliverCode.product) {
        //            orderService.setProductName(deliverCode.product.name);
        //        }

        //        this.setState({ salesCodes: salesCodes });
        //    }
        //});
    };

    changeSalesCodeSelect(selectedOption) {
        var deliverCodes = this.state.deliverCodes;
        var currentSelectDeliverCode = selectedOption || this.state.deliverAccountCode;

        // console.log(currentSelectDeliverCode);
        deliverCodes.forEach((deliverCode) => {
            if (currentSelectDeliverCode != null && deliverCode.code === currentSelectDeliverCode.value) {

                var selSalesCode = '';
                var salesCodes = deliverCode.salesAccountCodes;
                if (this.props.model.isOtherPlatform) {
                    salesCodes = this.state.otherPlatformSalesCode.map(x => x.code);
                }
                if (salesCodes.length > 0) {
                    selSalesCode = salesCodes[0]
                }
                console.log(selSalesCode);
                let model = this.props.model;
                model.deliverAccountCode = deliverCode.code;
                model.saleAccountCode = selSalesCode;
                model.addressee = deliverCode.addressee;
                model.zipcode = deliverCode.zipcode;
                model.phone = deliverCode.phone;
                model.address = deliverCode.address;
                if (deliverCode.product) {
                    orderService.setCurrentProduct(deliverCode.product);
                }

                this.setState({ salesCodes: salesCodes });
            }
        });
    }

    async populateDeliverCodeData() {
        const token = await authService.getAccessToken();
        const company = this.props.company;
        const response = await fetch('dealer/GetDeliverAccountCodes?id=' + this.state.dealerId + '&company=' + company, {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        const data = await response.json();
        var dealerId = data.dealerId;
        var dealerName = data.dealerName;
        var deliverCodes = data.deliverAccountCodes;

        var length = deliverCodes.length;

        var selectedDeliverCode = this.props.model.deliverAccountCode;
        var selectedSalesCode = this.props.model.saleAccountCode;

        var salesCodes = [];
        if (!selectedDeliverCode) {

            if (length >= 1) {
                // console.log(deliverCodes);
                selectedDeliverCode = deliverCodes[0].summary;

                if (!selectedSalesCode && deliverCodes[0].salesAccountCodes.length > 0) {

                    salesCodes = deliverCodes[0].salesAccountCodes;
                    selectedSalesCode = deliverCodes[0].salesAccountCodes[0];
                }
            }
        }
        else {
            deliverCodes.forEach((deliverCode) => {
                if (deliverCode.code === selectedDeliverCode) {
                    salesCodes = deliverCode.salesAccountCodes;
                    if (salesCodes.length > 0) {
                        if (selectedSalesCode === '') {
                            selectedSalesCode = salesCodes[0]

                        }
                    }
                    var label = selectedDeliverCode;
                    if (deliverCode.product) {
                        label += " " + deliverCode.product.name;
                        orderService.setCurrentProduct(deliverCode.product);
                    }

                    this.setState({ deliverAccountCode: { label: label, value: selectedDeliverCode } });
                }
            });
        }
        if (this.props.model.isOtherPlatform && data.otherPlatformSalesAccountCodes.length > 0) {
            dealerName = dealerName + "/" + data.otherPlatformSalesAccountCodes[0].dealerName;
            this.setState({ salesCodes: data.otherPlatformSalesAccountCodes.map(x => x.code) });
        } else {
            this.setState({ salesCodes: salesCodes });
        }
        console.log(salesCodes);
        this.setState({ deliverCodes: deliverCodes, defaultSalesCodes: salesCodes, otherPlatformSalesCode: data.otherPlatformSalesAccountCodes, dealerName: dealerName, loading: false });

        const userDeliverAccountCode = authService.getCurrentUser().deliverAccountCode;
        //  console.log(this.state.deliverCodes);
        if (!this.state.deliverAccountCode || this.state.deliverAccountCode.length == 0) {
            const temp = this.state.deliverCodes.filter(x => x.code == userDeliverAccountCode);
            if (temp.length > 0) {
                this.setState({ deliverAccountCode: { label: temp[0].code, value: temp[0].code } });
                this.changeSalesCodeSelect();
            }
        }
    }

    renderDeliverCodes() {
        var deliverAccountCode = this.props.model.deliverAccountCode
        if (deliverAccountCode == null) {
            deliverAccountCode = '';
        }
        const customStyles = {
            control: (base, state) => ({
                ...base,
                "*": {
                    boxShadow: "none !important",
                },
            }),
        }

        return (<Select onChange={this.onSelectChange}
            closeMenuOnSelect={true}
            styles={customStyles}
            value={this.state.deliverAccountCode}
            options={this.state.deliverCodes.map(x => {
                if (x.product) {
                    return { label: x.code + " " + x.product.name, value: x.code }
                }
                return { label: x.code, value: x.code }

            })}
            //  onInputChange={this.handleOnSearch}
            placeholder=""
            isClearable={true}
        />);


        //<ReactSearchAutocomplete
        //    items={this.state.deliverCodes}
        //    onSearch={this.handleOnSearch}
        //    onHover={this.handleOnHover}
        //    onSelect={this.handleOnSelect}
        //    onFocus={this.handleOnFocus}
        //    styling={{ borderRadius: "5px", height: "36px", margin: "5px", fontSize: "14px", boxShadow: "none" }}
        //    fuseOptions={{ keys: ["code"] }}
        //    resultStringKeyName="code"
        //    inputSearchString={deliverAccountCode}
        //    showIcon={false}
        //    maxResults="8"
        ///>
    }

    CheckFieldRequiredInvalid(field) {

        let trimfield = !field ? '' : field.trim();
        if (trimfield === '') {
            return true;
        }
        return false;
    }

    validate() {

        var model = this.props.model;
        if (this.CheckFieldRequiredInvalid(model.deliverAccountCode)) {
            return { state: false, msg: "DeliverAccountCodeRequired" };
        }

        if (this.CheckFieldRequiredInvalid(model.saleAccountCode)) {
            return { state: false, msg: "SaleAccountCodeRequired" };
        }

        if (this.CheckFieldRequiredInvalid(model.addressee)) {
            return { state: false, msg: "AddresseeRequired" };
        }

        if (this.CheckFieldRequiredInvalid(model.phone)) {
            return { state: false, msg: "PhoneRequired" };
        }

        if (this.CheckFieldRequiredInvalid(model.address)) {
            return { state: false, msg: "ReceivingAddressRequired" };
        }

        return { state: true };
    }

    render() {
        let model = this.props.model;
        if (!model) {
            return null;
        }
        // console.log(model);
        let deliverContents = this.state.loading
            ? <p><em>loadingDeliverCode...</em></p>
            : this.renderDeliverCodes();
        let className = "grid grid-cols-6 gap-6 " + this.props.classnames;
        return <div className={className}>
            <div className="col-span-4" >
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="DealerName" /></label>
                <BaseTextBox classnames="mt-1" type="text" name="dealerName" disabled value={this.state.dealerName} />
            </div>
            <div className="col-span-2 place-content-end">
                <label className="inline-flex items-center">
                    <BaseCheckBox type="checkbox" value={model.isOtherPlatform} checked={model.isOtherPlatform === true} onChange={this.handleIsOtherPlatformChange}></BaseCheckBox>
                    <span class="ml-1"><FormattedMessage id="IsTingzhanUser" /></span>
                    <div className="relative inline-block tooltip-container">
                        <label
                            className="w-5 h-5 rounded-full bg-blue-800 flex items-center justify-center cursor-pointer"
                            onClick={this.handleTooltipClick}
                        >
                            <span className="text-white text-sm font-medium">?</span>
                        </label>
                        {this.state.showTooltip && (
                            <div className="absolute -translate-x-1/2 bottom-full mb-2 z-10">
                                <div className="bg-gray-500 text-white text-sm rounded-lg py-2 px-3 whitespace-nowrap">
                                    <FormattedMessage id="TingzhanTip"/>
                                    <div className="absolute left-2.5 -bottom-1 w-2 h-2 bg-gray-500 transform rotate-45"></div>
                                </div>
                            </div>
                        )}
                    </div>
                </label>
                
            </div>
            <div className="col-span-6 sm:col-span-3">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="DeliverAccountCode" /><span className="font-bold text-red-600">*</span></label>
                <div className="mt-1" > {deliverContents}</div>
            </div>
            <div className="col-span-6 sm:col-span-3">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="SaleAccountCode" /><span className="font-bold text-red-600">*</span></label>
                <SalesCodeComboBox classnames="mt-1 h-10 text-sm" name="saleAccountCode" isOtherPlatform={model.isOtherPlatform} items={this.state.salesCodes} selectedValue={model.saleAccountCode} onSelectValueChanged={this.handleSalesCodeChanged} />
            </div>

            <div className="col-span-6 sm:col-span-6 lg:col-span-3">

                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Addressee" /><span className="font-bold text-red-600">*</span></label>
                <BaseTextBox disabled classnames="mt-1" type="text" name="addressee" value={model.addressee ?? ""} onChange={this.handleInputChange} />
            </div>
            <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Phone" /><span className="font-bold text-red-600">*</span></label>
                <BaseTextBox disabled classnames="mt-1" type="text" name="phone" value={model.phone ?? ""} onChange={this.handleInputChange} />
            </div>
            <div className="col-span-6" >
                <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Address" /><span className="font-bold text-red-600">*</span></label>
                <BaseTextArea disabled value={model.address ?? ""} name="address" onChange={this.handleInputChange} />
            </div>
        </div>
    }
}
